import { Popover as PopoverPrimitive } from "radix-ui";
import type * as React from "react";
import { popoverContentClass } from "@crow/ui/popover";
import { cn } from "../../lib/utils";

/** The design system's popover surface (`design-system/ui`), under the compound API of Radix. */
function Popover(props: React.ComponentProps<typeof PopoverPrimitive.Root>) {
	return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger(props: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
	return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverContent({
	className,
	align = "center",
	sideOffset = 6,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
	return (
		<PopoverPrimitive.Portal>
			<PopoverPrimitive.Content
				align={align}
				className={cn(
					popoverContentClass,
					"z-popover origin-(--radix-popover-content-transform-origin)",
					className,
				)}
				data-slot="popover-content"
				sideOffset={sideOffset}
				{...props}
			/>
		</PopoverPrimitive.Portal>
	);
}

const PopoverClose = PopoverPrimitive.Close;

/** Positions the content against another element than its trigger. */
const PopoverAnchor = PopoverPrimitive.Anchor;

export { Popover, PopoverAnchor, PopoverClose, PopoverContent, PopoverTrigger };
